/*
 * Copyright (C) 2026 Fluxer Contributors
 *
 * This file is part of Fluxer.
 *
 * Fluxer is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * Fluxer is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Fluxer. If not, see <https://www.gnu.org/licenses/>.
 */

export type AppSentryModule = typeof import('@sentry/react');

let sentryModule: AppSentryModule | null = null;
let sentryModulePromise: Promise<AppSentryModule> | null = null;

export async function loadSentryModule(): Promise<AppSentryModule> {
	if (sentryModule) {
		return sentryModule;
	}

	if (!sentryModulePromise) {
		sentryModulePromise = import('@sentry/react').then((module) => {
			sentryModule = module;
			return module;
		});
	}

	return await sentryModulePromise;
}

export function captureSentryException(error: Error): void {
	sentryModule?.captureException(error);
}

export function setSentryUser(user: {id?: string; username?: string; email?: string} | null): void {
	sentryModule?.setUser(user);
}
